<template>
  <div>
    <vue-dropzone
      v-show="!file"
      ref="uploadPdf"
      id="dropzone"
      :options="dropzoneOptions"
      :useCustomSlot="true"
      :duplicateCheck="true"
      @vdropzone-file-added="_handler"
      @vdropzone-error="_removeFile"
      @vdropzone-success="_onUploadSuccess"
    >
      <div class="dropzone-custom-content">
        <div class="dropzone-dnd-text-wrapper">
          <img :src="dndIcon" alt="dnd-icon" />
          <span>{{label}}</span>
        </div>

        <div class="divider-text">OR</div>

        <VButton
          label="Add File"
          size="regular"
          extraClass="dnd-upload-button"
        />
      </div>
    </vue-dropzone>

    <div
      v-if="file"
      class="file-exists"
      :class="{ ['loading']: isFileLoading }"
    >
      <span class="filename"> {{ file.name }} </span>

      <div
        @mouseover="hovered = true"
        @mouseleave="hovered = false"
        class="remove"
        @click="_removeFile"
      >
        <span> Remove </span>
        <img :src="image" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import VButton from "@/components/VButton";

import dndIcon from "@/assets/images/dnd-icon.svg";
import removeIcon from "@/assets/images/context-menu/remove.svg";
import removeIconActive from "@/assets/images/context-menu/remove-active.svg";

import { apiUrl } from "@/config";

export default Vue.component("VUploaderDropZone", {
  props: {
    label: VueTypes.string.def("Drag and Drop Files Here"),
    maxFiles: VueTypes.number.def(1),
    fileTypes: VueTypes.array
  },
  components: {
    vueDropzone: vue2Dropzone,
    VButton
  },

  data() {
    return {
      dndIcon,

      file: null,
      file_type: null,
      removeIcon,
      removeIconActive,
      hovered: false,
      file_url: null,
      isFileLoading: false
    };
  },

  computed: {
    dropzoneOptions() {
      return {
        maxFiles: this.maxFiles,
        url: this._uploadFile,
        maxFilesize: 15,
        withCredentials: true,
        createImageThumbnails: false,
        clickable: ".dnd-upload-button",
        acceptedFiles: this.fileTypes
      };
    },
    image() {
      return this.hovered ? removeIconActive : removeIcon;
    }
  },

  methods: {
    _getDzInstance() {
      return this.$refs.uploadPdf;
    },

    _getFileName(file) {
      return file.split(".")[0];
    },

    _handler() {
      this.file = this._getDzInstance().getAddedFiles()[0];
      // this.$emit("fileupload", this.file);
    },

    _removeFile() {
      this._getDzInstance().removeAllFiles();
      this.file = null;
      this.file_type = null;
    },

    _uploadFile(files) {
      this._getDzInstance().setOption("headers", {
        "X-Inkit-Filename": files[0].name
      });
      this.isFileLoading = true;
      this.$emit("upload-start");

      return `${apiUrl}/upload-file`;
    },

    _onUploadSuccess(file, response) {
      this.file_url = response.file_id;
      this.file_type = file.type === "application/pdf" ? "pdf" : "html";
      this.$emit("upload-finish", this.file_url, this.file_type);
      this.isFileLoading = false;
    }
  }
});
</script>

<style lang="scss" scoped>
#dropzone {
  border: 1px dashed $primary-text-color;
  border-radius: 3px;
  height: 353px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &:hover {
    background: transparent;
  }
}

.dropzone-dnd-text-wrapper {
  display: flex;
  flex-direction: column;

  span {
    font-size: 15px;
    font-family: Lato-Regular, sans-serif;
    color: $tertiary-text-color;
  }
}

.divider-text {
  margin: 30px 0;
  font-family: Lato-Bold, sans-serif;
  font-size: 15px;
}

button.dnd-upload-button.primary {
  background: transparent;
  border-color: $tertiary-text-color;
  color: $tertiary-text-color;

  &:hover {
    background: #f6f6f6;
  }
}

.file-exists {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .remove {
    display: flex;
    align-items: center;
    cursor: pointer;

    img {
      width: 30px;
      height: 30px;
      margin-left: 5px;
    }

    span {
      font-family: Lato-Light, sans-serif;
      color: $secondary-text-color;
      font-size: 15px;
    }

    &:hover {
      span {
        color: $primary-color;
      }
    }
  }

  .filename {
    font-size: 22px;
    color: $primary-color;
  }

  &.loading {
    opacity: 0.25;
    pointer-events: none;
  }
}
</style>
